import {
  EnhancedDropDown,
  IEnhancedDropDown,
  IEnhancedDropDownItem,
} from "../EnhancedDropDown";

import React from "react";
import { useController } from "react-hook-form";

export interface IEnhancedDropDownRHF
  extends Pick<
    IEnhancedDropDown,
    Exclude<
      keyof IEnhancedDropDown,
      "onChangeHandler" | "isMulti" | "helperText"
    >
  > {
  onSelectionChangeHandler?: (item: IEnhancedDropDownItem | any) => void;
  // resetSelection?: boolean;
}

/**
 * React Hook Form Drop Down component.
 */
export const EnhancedDropDownRHF: React.FC<IEnhancedDropDownRHF> = ({
  selectName,
  selectedItem,
  showEmpty,
  isDisabled = false,
  isHide = false,
  // resetSelection = false,
  items,
  testId,
  isSearchable,
  onSelectionChangeHandler,
}) => {
  const {
    field: { onChange, value, ref },
    formState: { errors },
  } = useController({
    name: selectName,
    defaultValue: selectedItem,
  });

  const onDDLChange = (choosedItem: IEnhancedDropDownItem | any) => {
    if (choosedItem) {
      onChange(choosedItem.value);
      if (onSelectionChangeHandler) {
        onSelectionChangeHandler(choosedItem);
      }
    } else {
      onChange(null);
      if (onSelectionChangeHandler) {
        onSelectionChangeHandler(null);
      }
    }
  };

  return (
    <EnhancedDropDown
      ref={ref}
      items={items}
      selectedItem={value}
      showEmpty={showEmpty}
      testId={testId}
      selectName={selectName}
      isDisabled={isDisabled}
      isHide={isHide}
      isSearchable={isSearchable}
      onChangeHandler={(val: any) => onDDLChange(val)}
      helperText={errors[selectName]?.message}
      error={!!errors[selectName]}
    />
  );
};
